export default __webpack_public_path__ + "static/media/cd-disk.6a90d272.mp3";